import format from 'date-fns/format'
import addDays from 'date-fns/addDays'
import parse from 'date-fns/parse'
import compareAsc from 'date-fns/compareAsc'
import isValid from 'date-fns/isValid'
import getURLSearchParam from './base/url'
import { reportInfo } from './owl'

const FORMAT = 'yyyyMMdd'

export function dateNow() {
  // 用于MOCK当前时间 '2022/12/08 02:00:00'
  return new Date()
}

export function dateNowTime() {
  return dateNow().getTime()
}

// 简查参数合法性
function checkDate(dateBegin: string, dateEnd: string) {
  const dateB = parse(dateBegin, FORMAT, dateNow())
  const dateE = parse(dateEnd, FORMAT, dateNow())
  if (!isValid(dateB) || !isValid(dateE)) {
    return false
  }
  if (compareAsc(addDays(dateNowTime(), dateNow().getHours() < 3 ? -2 : -1), dateB) !== -1) {
    return false
  }
  if (compareAsc(dateB, dateE) !== -1) {
    return false
  }
  return true
}

function pipeAddDaysAmount({
  dateBegin,
  dateEnd,
  addDaysAmount,
}: {
  dateBegin: string | Date
  dateEnd: string | Date
  addDaysAmount: number
}) {
  const _dateB = typeof dateBegin === 'string' ? parse(dateBegin, FORMAT, dateNow()) : dateBegin
  const _dateE = typeof dateEnd === 'string' ? parse(dateEnd, FORMAT, dateNow()) : dateEnd
  if (addDaysAmount && addDaysAmount > 0) {
    const dateB = addDays(_dateB, addDaysAmount)
    const dateE = addDays(_dateE, addDaysAmount)
    return {
      dateBegin: format(dateB, FORMAT),
      dateEnd: format(dateE, FORMAT),
    }
  }
  return {
    dateBegin: format(_dateB, FORMAT),
    dateEnd: format(_dateE, FORMAT),
  }
}

// 用于获取入离日期参数
// dateBegin  =>    开始时间 => 年月日
// dateEnd    =>    结束时间 => 年月日 => 如果日期格式不合法的话，则取今明两日
export default function getDefaultDate({
  dateBegin,
  dateEnd,
  addDaysAmount = 0,
  noQueryDate = false,
}: {
  dateBegin?: string
  dateEnd?: string
  addDaysAmount?: number
  noQueryDate?: boolean
} = {}) {
  // 固定日期
  if (dateBegin && dateEnd) {
    if (checkDate(dateBegin, dateEnd)) {
      return pipeAddDaysAmount({ dateBegin, dateEnd, addDaysAmount })
    } else {
      reportInfo({
        name: '传入日期参数错误,兜底为默认参数',
        global: true,
        msg: dateBegin + '; ' + dateEnd,
      })
    }
  }
  if (!noQueryDate) {
    // query 参数取
    const queryDateBegin = getURLSearchParam('dateBegin')
    const queryDateEnd = getURLSearchParam('dateEnd')
    if (queryDateBegin && queryDateEnd) {
      if (checkDate(queryDateBegin, queryDateEnd)) {
        return pipeAddDaysAmount({
          dateBegin: queryDateBegin,
          dateEnd: queryDateEnd,
          addDaysAmount,
        })
      } else {
        reportInfo({
          name: '链接日期参数错误,兜底为默认参数',
          global: true,
          msg: queryDateBegin + '; ' + queryDateEnd,
        })
      }
    }
  }
  // T+N
  const today = dateNow()
  const tomorrow = addDays(today, 1)
  if (today.getHours() < 20) {
    return pipeAddDaysAmount({
      dateBegin: today,
      dateEnd: tomorrow,
      addDaysAmount,
    })
  } else {
    const afterTomorrow = addDays(today, 2)
    return pipeAddDaysAmount({
      dateBegin: tomorrow,
      dateEnd: afterTomorrow,
      addDaysAmount,
    })
  }
}
